import React from 'react';

import { CustomTypography } from '@/shared/ui/Typography';

import { StyledLi, StyledOl } from './styles/channelStepsListStyles';

interface ChannelStepsListProps {
  steps: string[];
}

export const ChannelStepsList: React.FC<ChannelStepsListProps> = ({
  steps,
}) => {
  if (!steps.length) {
    return null;
  }

  return (
    <StyledOl>
      {steps.map((step, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <StyledLi key={index}>
          <CustomTypography variant="body1">{step}</CustomTypography>
        </StyledLi>
      ))}
    </StyledOl>
  );
};
